import { isAfter, isSameDay, isValid, parse, startOfDay } from 'date-fns';

export const validateDateOfBirth = (value: string, format = 'MM/dd/yyyy') => {
  const regex = /\s/g;

  // only use trimmedValue if format doesn't have spaces
  const trimmedValue = format.match(regex) ? value : value.replace(regex, '');
  const dob = parse(trimmedValue, format, new Date());

  if (!isValid(dob)) {
    return `Must be valid date in format ${format}`;
  }

  const now = startOfDay(new Date());
  if (isSameDay(dob, now) || isAfter(dob, now)) {
    return 'Date must be in the past';
  }

  return undefined;
};
